/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Sync_Col_StatusInputs */

const cs_portals_sync_col_status = /** @type {(inputs: Portals_Sync_Col_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoda`)
};

const en_portals_sync_col_status = /** @type {(inputs: Portals_Sync_Col_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Match`)
};

/**
* | output |
* | --- |
* | "Match" |
*
* @param {Portals_Sync_Col_StatusInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_sync_col_status = /** @type {((inputs?: Portals_Sync_Col_StatusInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Sync_Col_StatusInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_sync_col_status(inputs)
	return cs_portals_sync_col_status(inputs)
});